export enum FeatureType
{
    Rewards = 0,
    Protect = 1
}